import {
  branch,
  compose, getContext, renderNothing,
} from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { propOr } from 'ramda';
import EditTaskModal from './editTaskModal';
import rules from '../modalViewTasks/rules';
import withCRUDTask from '../../../../utils/enchancers/withCRUDTask';
import {
  setTaskData,
} from '../../../../utils/helpers/taskHelpers/crudHelper';
import { tasksActions } from '../../../../state/tasks';
import { leadsActions, leadsSelectors } from '../../../../state/leads';
import { TASKS_WITHOUT_PROJECT } from '../../../../constants/tasks';

const mapStateToProps = (state, { selectedLeadTask }) => ({
  task: leadsSelectors.getLeadTaskSelector(state)(selectedLeadTask),
});

const mapDispatchToProps = ({
  editTask: tasksActions.updateTaskRequest,
  getLeadTasks: leadsActions.getLeadTasksRequest,
  getLeadLogs: leadsActions.getLeadLogsRequest,
  editLeadTaskSuccess: leadsActions.editLeadTaskSuccess,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(['common', 'tasks']),
  getContext({
    selectedLeadId: PropTypes.any,
  }),
  branch(
    ({ task }) => !task,
    renderNothing,
  ),
  withCRUDTask({
    rules,
    data: ({ task }) => task,
    modalName: 'editPartOfTaskModal',
    onSubmit: (formValues, {
      resetForm,
      props: {
        editTask, onSuccess, selectedLeadId, getLeadTasks, onCloseModal, task,
        getLeadLogs, editLeadTaskSuccess,
      },
    }) => {
      editTask(
        {
          ...setTaskData(
            formValues,
          ),
          status: task.status,
          status_id: task.status_id,
          projectId: propOr(TASKS_WITHOUT_PROJECT, 'project_id', task),
          id: task.id,
          leadId: selectedLeadId,
          clientId: selectedLeadId,
        }, {
          section: 'project',
          callbacks: {
            success: () => {
              resetForm({});
              onCloseModal('editPartOfTaskModal');
              getLeadTasks({ id: selectedLeadId });
              getLeadLogs({ id: selectedLeadId });
              editLeadTaskSuccess({ selectedLeadId });
              if (onSuccess) {
                onSuccess();
              }
            },
          },
        },
      );
    },
  }),
);

export default enhance(EditTaskModal);
